import React, { FC, useState } from 'react';
import _ from 'lodash';
import { ParamsProps } from '../../../../../common/components/ParamsProvider';
import { useDataProvider } from 'src/app/common/utils';
import { useDispatch } from 'react-redux';
import PruFilter, { PruFilterItemType } from 'src/app/common/components/PruTable/PruFilter';
import { useIntl } from 'react-intl';
import { useServerLocale } from 'src/app/i18n';
import { WalletCreditListParam, WalletCreditListRes } from '../../../types/credit-type';
import WalletCreditList from './components/WalletCreditList';
import { getWalletCreditList } from '../../../network/creditCrud';

type CreditListingPageProps = {} & ParamsProps;

const initialState: WalletCreditListParam = {
  pageSize: 5,
  page: 1,
};

const paramsInitiator = (initialParams?: Record<string, string>): WalletCreditListParam => {
  return initialParams
    ? {
        page: 1,
        pageSize: 5,
      }
    : initialState;
};

export const walletCreditFilterKeys = [];
const filterWidth = { width: 200 };
const CreditListingPage: FC<CreditListingPageProps> = ({ initialParams, onChangeQueryParams }) => {
  const locale = useServerLocale();
  const dispatch = useDispatch();
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });

  const [filterState, setFilterState] = useState<WalletCreditListParam>(paramsInitiator(initialParams));

  const [listRes, setListRes] = useState<WalletCreditListRes>();
  const { isLoading, refreshData } = useDataProvider<WalletCreditListRes>(
    async () => {
      try {
        if (onChangeQueryParams) {
          onChangeQueryParams(filterState);
        }
        return await getWalletCreditList(filterState, dispatch);
      } catch (err) {}
    },
    setListRes,
    false,
  );

  return (
    <>
      <PruFilter
        title={Translation('walletCredit.filter')}
        itemDef={[
          {
            type: PruFilterItemType.FREE_TEXT,
            style: filterWidth,
            field: 'agentCode',
            initialValue: filterState.agentCode,
            displayName: Translation('walletCredit.common.agentCode'),
          },
          {
            type: PruFilterItemType.DATE_RANGE,
            fieldFrom: 'transactionDateFrom',
            fieldTo: 'transactionDateTo',
            initialDateFrom: filterState.transactionDateFrom,
            initialDateTo: filterState.transactionDateTo,
            displayName: Translation('walletCredit.common.transactionDate'),
          },
          {
            type: PruFilterItemType.DATE_RANGE,
            fieldFrom: 'expiryDateFrom',
            fieldTo: 'expiryDateTo',
            initialDateFrom: filterState.expiryDateFrom,
            initialDateTo: filterState.expiryDateTo,
            displayName: Translation('walletCredit.common.expiryDate'),
          },
        ]}
        onChangeFilter={(data) => {
          setFilterState({
            ...filterState,
            agentCode: data?.agentCode.trim() ?? '',
            transactionDateFrom: data.transactionDateFrom,
            transactionDateTo: data.transactionDateTo,
            expiryDateFrom: data.expiryDateFrom,
            expiryDateTo: data.expiryDateTo,
          });
        }}
        fetchData={refreshData}
      />
      <WalletCreditList
        isLoading={isLoading}
        listRes={listRes}
        onRefresh={refreshData}
        onChangePage={(page, rowsPerPage) => {
          setFilterState({
            ...filterState,
            page,
            pageSize: rowsPerPage,
          });
          refreshData();
        }}
      />
    </>
  );
};

export default CreditListingPage;
